export type StickerCategories = 'boats' | 'actions' | 'things';
export type StickerConfig = {
  name: string;
  width: number;
  height: number;
  slug?: string;
  category?: StickerCategories;
  reducedMarginsLarge?: boolean;
  reducedMarginsMedium?: boolean;
};
const stickers: StickerConfig[] = [
  {
    name: 'yacht',
    width: 557,
    height: 222,
    slug: 'yacht-rentals',
    category: 'boats',
  },
  {
    name: 'jet-ski',
    width: 353,
    height: 200,
    slug: 'jet-ski-rental',
    category: 'boats',
  },
  {
    name: 'sailboat',
    width: 240,
    height: 323,
    slug: 'sailboat-rental',
    category: 'boats',
  },
  {
    name: 'kayak',
    width: 338,
    height: 181,
    slug: 'kayak-rentals',
    category: 'boats',
  },
  {
    name: 'canoe',
    width: 283,
    height: 220,
    slug: 'canoe-rentals',
    category: 'boats',
  },
  {
    name: 'wakeboat',
    width: 462,
    height: 225,
    slug: 'wakeboarding',
    category: 'boats',
  },
  {
    name: 'fishing-charter',
    width: 423,
    height: 306,
    slug: 'fishing-charters',
    category: 'boats',
  },
  {
    name: 'rafting',
    width: 316,
    height: 260,
    slug: 'rafting',
  },
  {
    name: 'fishing-boat',
    width: 444,
    height: 325,
    slug: 'fishing-boat-rental',
    category: 'boats',
  },
  {
    name: 'jon-boat',
    width: 529,
    height: 187,
  },
  {
    name: 'catamaran',
    width: 347,
    height: 207,
    slug: 'cruising-catamaran-rental',
    category: 'boats',
  },
  {
    name: 'backflip',
    width: 308,
    height: 263,
    category: 'actions',
  },
  {
    name: 'diver',
    width: 339,
    height: 211,
    slug: 'diving',
  },
  {
    name: 'paddleboard',
    width: 264,
    height: 255,
    slug: 'paddleboard-rentals',
    category: 'actions',
  },
  {
    name: 'relax',
    width: 294,
    height: 242,
    category: 'actions',
  },
  {
    name: 'snorkle',
    width: 164,
    height: 217,
    slug: 'snorkeling',
    category: 'actions',
  },
  {
    name: 'anemone',
    width: 263,
    height: 233,
    category: 'things',
  },
  {
    name: 'dolphin',
    width: 385,
    height: 174,
  },
  {
    name: 'fish',
    width: 297,
    height: 232,
    category: 'things',
  },
  {
    name: 'floaty',
    width: 290,
    height: 173,
  },
  {
    name: 'ray',
    width: 479,
    height: 206,
  },
  {
    name: 'seagull',
    width: 327,
    height: 224,
    category: 'things',
    reducedMarginsLarge: true,
  },
  {
    name: 'shell',
    width: 368,
    height: 197,
  },
  {
    name: 'starfish',
    width: 259,
    height: 253,
    category: 'things',
  },
  {
    name: 'turtle',
    width: 381,
    height: 172,
  },
  {
    name: 'whale',
    width: 229,
    height: 219,
    slug: 'whale-watching',
    category: 'things',
  },
  {
    name: 'houseboat',
    width: 491,
    height: 191,
    slug: 'houseboat-rentals',
  },
  {
    name: 'pontoon',
    width: 447,
    height: 265,
    slug: 'pontoon-boat-rentals',
  },
  {
    name: 'tours',
    width: 238,
    height: 288,
    slug: 'tours',
  },
  {
    name: 'rib',
    width: 425,
    height: 202,
  },
  {
    name: 'gulet',
    width: 255,
    height: 353,
  },
  {
    name: 'center-console',
    width: 495,
    height: 183,
  },
  {
    name: 'bass-boat',
    width: 552,
    height: 186,
  },
  {
    name: 'ring-floaty',
    width: 382,
    height: 362,
    reducedMarginsMedium: true,
  },
  {
    name: 'heart-sunglasses',
    width: 336,
    height: 297,
    reducedMarginsLarge: true,
  },
  {
    name: 'party-floaty',
    width: 252,
    height: 214,
  },
  {
    name: 'cupcake',
    width: 162,
    height: 170,
  },
] as const;

export default stickers;
